import { render } from "./PrincipalLobbyClientComponent.vue?vue&type=template&id=be6ad63c&scoped=true"
import script from "./PrincipalLobbyClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalLobbyClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalLobbyClientComponent.vue?vue&type=style&index=0&id=be6ad63c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6ad63c"]])

export default __exports__